export const servicesLinks = [
  {
    uuid: 1,
    label: "Field Performance Testing",
    href: "fieldPerformanceTesting",
  },
  {
    uuid: 2,
    label: "Network Benchmark Testing",
    href: "networkBenchmarkTesting",
  },
  {
    uuid: 3,
    label: "Tuner and Media Testing",
    href: "tunerAndMediaTesting",
  },
  {
    uuid: 4,
    label: "SoS Calls Testing",
    href: "sosCallsTesting",
  },

  {
    uuid: 5,
    label: "Web Development",
    href: "webAppDev",
  },

  {
    uuid: 6,
    label: "GPS Testing",
    href: "gpsTesting",
  },

  {
    uuid: 7,
    label: "Human Machine Interface Testing",
    href: "hmiTesting",
  },
];

export const visGroupLinks = [
  {
    label: "Vision Professional Services",
    herf: "https://www.vision-ps.de/",
  },
  {
    label: "Viscom Engineering Services SRL",
    herf: "https://viscom-es.com/",
  },
  {
    label: "Perform Engineering Services LTD",
    herf: "https://perform-es.com/",
  },
  {
    label: "BrainTime Technologies ",
    herf: "https://braintime-tech.com/",
  },
  {
    label: "Al Mafaheem Technologies",
    herf: "https://mafaheem-tech.com/",
  },
];
